import PropTypes from 'prop-types';
import React from 'react';
// @mui
import { Box, Button, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import { useLocation } from 'react-router-dom';
// theme
import { bgBlur } from 'src/theme/css';
// hooks
import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import Iconify from 'src/components/iconify';
import Logo from 'src/components/logo';
import { useSettingsContext } from 'src/components/settings';

//
import { AGENT } from 'src/_config/brandConfig';
import { useAuthContext } from 'src/auth/hooks';
import OnTimeGuaranteeModal from 'src/components/custom-dialog/on-time-guarantee-modal';
import useBrandName from 'src/hooks/use-brand-name';
import { paths } from 'src/routes/paths';
import {
  AccountPopover
} from '../_common';
import { HEADER } from '../config-layout';
import NavMobile from '../main/nav/mobile';

// ----------------------------------------------------------------------
const mobileNavItems = [
  {
    title: 'Knowledge Hub',
    path: paths.blog.root,
    icon: <Box component="img" src="/assets/icons/navbar/knowledge.svg" />,
  },
  {
    title: 'Contact Us',
    path: paths.contact,
    icon: <Iconify icon="iconoir:headset-help" />,
  },
];
export default function Header({ onOpenNav }) {
  const { authenticated } = useAuthContext();

  const theme = useTheme();
  const { isTryVisa } = useBrandName();
  const settings = useSettingsContext();

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  const lgUp = useResponsive('up', 'lg');
  const smUp = useResponsive('up', 'sm');
  const mdDown = useResponsive('down', 'md');
  console.log('sizing', lgUp, smUp, mdDown);
  const offset = useOffSetTop(HEADER.H_DESKTOP);

  const offsetTop = offset && !isNavHorizontal;

  const location = useLocation();
  const isOrderPage = location.pathname === '/dashboard/order/list';
  const [openGuaranteeModal, setOpenGuaranteeModal] = React.useState(false);

  const renderContent = mdDown ? (
    <>
      <NavMobile data={mobileNavItems} />
      <Logo sx={{ mr: 1, width: 100, height: 24 }} />
      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        sx={{ minWidth: 0 }}
        spacing={{ xs: 1, sm: 1, md: 3 }}
      >
        {/* {authenticated && (
          <IconButton size="large" color="primary">
            <NotificationsPopover />
          </IconButton>
        )} */}
        {authenticated && <AccountPopover />}
        {!authenticated && (
          <Button
            variant="contained"
            color="secondary"
            size="small"
            sx={{
              background: 'var(--Bg, #F9F9F9)',
              color: 'text.primary',
              padding: '4px 18px',
              '&:hover': {
                background: '#e0e0e0', // Light gray hover color
                color: 'text.primary',
              },
            }}
            href={paths.auth.firebase.login}
          >
            Sign In
          </Button>
        )}
      </Stack>
    </>
  ) : (
    <>
      {/* {lgUp && isNavHorizontal &&  } */}
      <Logo sx={{ mr: 4, width: { xs: 100, sm: 'unset' } }} />
      <Button
        variant="text"
        color="inherit"
        sx={{ color: '#FFFFFF', fontSize: 14 }}
        size="large"
        startIcon={<Box component="img" src="/assets/icons/navbar/knowledge.svg" />}
        href={paths.blog.root}
      >
        Knowledge Hub
      </Button>
      <Button
        variant="text"
        color="inherit"
        sx={{ color: '#FFFFFF', fontSize: 14 }}
        size="large"
        startIcon={<Iconify icon="iconoir:headset-help" />}
        href={paths.contact}
      >
        Contact us
      </Button>
      {/* {!lgUp && (
        <IconButton onClick={onOpenNav}>
          <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
        </IconButton>
      )}

      <Searchbar /> */}

      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{ xs: 1, sm: 1, md: 3 }}
      >
        {/* <LanguagePopover />

      

        <ContactsPopover />

        <SettingsButton /> */}
        {isTryVisa && !authenticated && (
          <Button
            variant="text"
            color="inherit"
            size="medium"
            sx={{
              padding: '7px 24px',
              height: 40, // Fixed height for consistency
              color: '#FFFFFF',

              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
            onClick={() => {
              window.location.href = AGENT.dashboardUrl;
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Box component="img" src="/assets/icons/navbar/agent.svg" />
              <Typography
                sx={{ color: '#FFFFFF', fontSize: 12, fontWeight: 600 }}
                typography="body1"
                color="inherit"
              >
                For Agents
              </Typography>
            </Stack>
          </Button>
        )}
        <Button
          variant="text"
          color="inherit"
          size="medium"
          sx={{
            height: 40,
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
          onClick={() => setOpenGuaranteeModal(true)}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box component="img" src="/assets/icons/navbar/guarantee.svg" />
            <Stack direction="column" spacing={0} alignItems="flex-start">
              <Typography
                sx={{ color: '#FFFFFF', fontSize: 12, fontWeight: 600, lineHeight: 1.2 }}
                typography="body1"
                color="inherit"
              >
                On Time
              </Typography>
              <Typography
                sx={{ color: '#FFFFFF', fontSize: 12, fontWeight: 600, lineHeight: 1.2 }}
                typography="body1"
                color="inherit"
              >
                Guaranteed
              </Typography>
            </Stack>
          </Stack>
        </Button>
        {/* <IconButton size="large" href={whatsappLink} target="_blank" color="primary">
          <Iconify icon="iconoir:headset-help" />
        </IconButton> */}
        {/* {authenticated && (
          <IconButton size="large" color="primary">
            <NotificationsPopover />
          </IconButton>
        )} */}
        {authenticated && <AccountPopover />}
        {!smUp && !authenticated && (
          <Button
            variant="contained"
            color="secondary"
            size="small"
            href={paths.auth.firebase.login}
          >
            Sign In
          </Button>
        )}
        {smUp && !isOrderPage && !authenticated && (
          <Button
            variant="contained"
            color="inherit"
            size="medium"
            sx={{
              height: 40,
              background: 'var(--Bg, #F9F9F9)',
              color: 'text.primary',
              padding: '7px 32px',
              '&:hover': {
                background: '#e0e0e0', // Light gray hover color
                color: 'text.primary',
              },
            }}
            href={paths.auth.firebase.login}
          >
            Sign In
          </Button>
        )}
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.secondary,
        }),
        backgroundColor: theme.palette.background.secondary,
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: 1,
          // `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
          height: HEADER.H_DESKTOP,
          ...(offsetTop && {
            height: HEADER.H_DESKTOP_OFFSET,
          }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: 'background.default',
            height: HEADER.H_DESKTOP_OFFSET,
            borderBottom: `dashed 1px ${theme.palette.divider}`,
          }),
          ...(isNavMini && {
            width: 1,
            // `calc(100% - ${NAV.W_MINI + 1}px)`,
          }),
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { xs: 2, md: 5 },
          overflowX: 'hidden', // Add this
          width: '100%',
          '& > *': {
            flexShrink: 0,
          },
        }}
      >
        {renderContent}
        <OnTimeGuaranteeModal
          open={openGuaranteeModal}
          onClose={() => setOpenGuaranteeModal(false)}
        />
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  onOpenNav: PropTypes.func,
};
